const EVENT_AUTH = 'EVENT_AUTH';
export default EVENT_AUTH;
